'use client';

import { useState } from 'react';
import { HiChevronDown } from 'react-icons/hi';

import { ContentRenderer } from '@portal/content-renderer';

export default function MobileCollapsibleSection({ document, ...rest }: { document: any[]; key?: string }) {
    const [collapsed, setCollapsed] = useState(false);
    const firstElement = document[0];
    const isCollapsible = firstElement?.type === 'heading';

    return (
        <section className="relative mb-8 bg-white py-4 md:py-8" {...rest}>
            {isCollapsible ? (
                <>
                    <HiChevronDown
                        aria-hidden
                        onClick={() => setCollapsed(!collapsed)}
                        className={`absolute right-4 top-4 cursor-pointer text-2xl transition duration-200 ease-out md:hidden ${
                            collapsed ? '' : ' rotate-180'
                        }`}
                    />

                    <div
                        className={`${collapsed ? '-mb-4 md:mb-0 ' : ''}cursor-pointer md:cursor-default`}
                        onClick={() => setCollapsed((collapsed) => !collapsed)}>
                        <ContentRenderer content={{ document: [firstElement] }} />
                    </div>
                    <div className={`${collapsed ? 'hidden md:block' : ''}`}>
                        <ContentRenderer content={{ document: document.slice(1) }} />
                    </div>
                </>
            ) : (
                <ContentRenderer content={{ document }} />
            )}
        </section>
    );
}
